import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth, useUser } from '@clerk/react';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../../redux/slice/user';
import { hardSignOut } from '../../services/authSession';
import { LuLayoutGrid, LuUsers, LuShieldAlert, LuWallet, LuMessagesSquare } from "react-icons/lu";
import { loadAdminData } from "../../services/adminDataStore";
import BrandLogo from '../../components/BrandLogo';
import { BarChart, GroupAddRounded, PieChart } from '@mui/icons-material';

// const location = useLocation()


const MainLayout = ({ children }) => {
  // const { user } = useAuth();
  const { user } = useSelector((state) => state.user);
  const { signOut } = useAuth();
  const { user: clerkUser } = useUser();
  const dispatch = useDispatch();
  const [showLeftMenue, setShowLeftMenue] = useState(false)
  const [showAccountMenu, setShowAccountMenu] = useState(false)
  const navigator = useNavigate();
  const location = useLocation();
  useEffect(() => {
    setShowAccountMenu(false);
  }, [location.pathname]);
  useEffect(() => {
    loadAdminData();
  }, []);
  const goToProfile = () => {
    console.log('Enrwechhsddh')
    navigator('/user/account');
  };

  const goToEditProfile = () => {
    navigator('/user/edit-profile');
  }
  const goToChangePassword = () => {
    navigator('/user/change-password');
  }

  const goToHelp = () => {
    navigator('/user/help');
  }
  const handleLogout = async () => {
    dispatch(logout())
    await hardSignOut(signOut)
  }

  return (
    <div className='body'>
      {/* <main className="custom-dashboard"> */}
      <div className="adminLayout">
        <div className={showLeftMenue ? "leftPanel show" : "leftPanel"}>

          <button className={showLeftMenue ? "mainDashboard-toggle active" : "mainDashboard-toggle"}
            onClick={() => setShowLeftMenue(!showLeftMenue)}>
            <div></div>
          </button>
          <div className="logoDiv">
            <Link to="/user/dashboard">
              <BrandLogo alt="TLK" />
            </Link>
          </div>
          <ul>
            <li>
              <Link to="/user/dashboard" className={location.pathname === "/user/dashboard" ? "active" : undefined} onClick={() => setShowLeftMenue(false)}>
                <LuLayoutGrid /><span>Dashboard</span>
              </Link>
            </li>
             <li>
              <Link to="/user/all-accounts" className={location.pathname === "/user/all-accounts" ? "active" : undefined} onClick={() => setShowLeftMenue(false)}>
                <GroupAddRounded /><span>Users</span>
              </Link>
            </li>
            <li>
              <Link to="/user/analytics" className={location.pathname === "/user/analytics" ? "active" : undefined} onClick={() => setShowLeftMenue(false)}>
                <PieChart /><span>Analytics</span>
              </Link>
            </li>
            <li>
              <Link to="/user/reports" className={location.pathname === "/user/reports" ? "active" : undefined} onClick={() => setShowLeftMenue(false)}>
                <BarChart /><span>User Reports</span>
              </Link>
            </li>
            <li>
              <Link to="/user/creators" className={location.pathname.startsWith("/user/creator") ? "active" : undefined} onClick={() => setShowLeftMenue(false)}>
                <LuUsers /><span>Creators</span>
              </Link>
            </li>
            <li>
              <Link to="/user/moderation" className={location.pathname === "/user/moderation" ? "active" : undefined} onClick={() => setShowLeftMenue(false)}>
                <LuShieldAlert /><span>Moderation</span>
              </Link>
            </li>
            <li>
              <Link to="/user/payouts" className={location.pathname === "/user/payouts" ? "active" : undefined} onClick={() => setShowLeftMenue(false)}>
                <LuWallet /><span>Payouts</span>
              </Link>
            </li>
            <li>
              <Link to="/user/conversations" className={location.pathname === "/user/conversations" ? "active" : undefined} onClick={() => setShowLeftMenue(false)}>
                <LuMessagesSquare /><span>Conversations</span>
              </Link>
            </li>
          </ul>
          <div className="sidebarAccount">
            <div className="dropdown">
              <div className="avtarBlock" onClick={() => setShowAccountMenu(!showAccountMenu)}>
                <div className="imgBlock">
                  {clerkUser?.imageUrl ? (
                    <img src={clerkUser.imageUrl} alt="" />
                  ) : (
                    <AccountCircleOutlinedIcon />
                  )}
                </div>
                <p>
                  {clerkUser?.fullName
                    || clerkUser?.firstName
                    || clerkUser?.primaryEmailAddress?.emailAddress
                    || "Admin"}
                </p>
              </div>
              <ul className={showAccountMenu ? "dropdown-menu show" : "dropdown-menu"} onClick={() => setShowAccountMenu(false)}>
                <li className="dropdown-menu-header">
                  <h5>Account</h5>
                  <button className="dropdown-close" type="button"><img src="/images/modaclosebtn.svg" alt="" /></button>
                </li>
                <li className="userAcountInfo">
                  <figure>
                    {clerkUser?.imageUrl ? (
                      <img src={clerkUser.imageUrl} alt="" />
                    ) : (
                      <AccountCircleOutlinedIcon />
                    )}
                    <figcaption>
                      <h4>{clerkUser?.firstName || "Admin"}</h4>
                      <p>{clerkUser?.primaryEmailAddress?.emailAddress || ""}</p>
                    </figcaption>
                  </figure>
                </li>
                <li>
                  <a className="dropdown-item" onClick={() => handleLogout()}><LogoutOutlinedIcon /> Logout</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="leftPanel-outerlayout" onClick={() => { setShowLeftMenue(false); setShowAccountMenu(false); }}></div>
        <div className="rightPanel">
          <button
            className={showLeftMenue ? "mobileNavToggle active" : "mobileNavToggle"}
            onClick={() => setShowLeftMenue(!showLeftMenue)}
            type="button"
            aria-label="Open menu"
          >
            <div></div>
          </button>
          {children}
          {/* <AuthFooter /> */}
        </div>
      </div>
    </div >
  );
};

MainLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default MainLayout;
